// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

export const isCustomEventNamesResult = objectOf({
  first_event_date: number,
  results: arrayOf(string),
  number_of_custom_events: number,
});
